module.exports = __webpack_public_path__ + "03_very_short_black.e2bb1803.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/papa/layer5/03_very_short_black.png
// module id = K69c
// module chunks = 0